import React from 'react'
import { useTwoFactorVerify } from './useTwoFactorVerify'
import { TwoFactorVerifyView } from './TwoFactorVerifyView'

export const TwoFactorVerify: React.FC = () => {
  const props = useTwoFactorVerify()
  return <TwoFactorVerifyView {...props} />
}
TwoFactorVerify.displayName = 'TwoFactorVerify'

export default TwoFactorVerify
